import { createContext, type ReactNode, useCallback, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { NotificationContainer } from "./NotificationContainer";

export type ToastType = "success" | "error" | "warn";

export interface Toast {
  id: string;
  message: string;
  type: ToastType;
  duration?: number;
}

interface NotificationContextProps {
  notify: (message: string, type: ToastType, duration?: number) => void;
}

export const NotificationContext =
  createContext<NotificationContextProps | null>(null);

export const NotificationProvider = ({ children }: { children: ReactNode }) => {
  const [toasts, setToasts] = useState<Toast[]>([]);

  const notify = useCallback(
    (message: string, type: ToastType, duration = 3500) => {
      const id = uuidv4();
      setToasts((prev) => [...prev, { id, message, type, duration }]);
    },
    [],
  );

  const remove = useCallback((id: string) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  return (
    <NotificationContext.Provider value={{ notify }}>
      {children}
      <NotificationContainer toasts={toasts} onRemove={remove} />
    </NotificationContext.Provider>
  );
};
